type ProductLabelInput = {
	barcode?: string | null;
	productName?: string | null;
};

export function formatProductLabel({
	barcode,
	productName,
}: ProductLabelInput): string {
	const code = barcode?.trim();
	const name = productName?.trim() ?? "";
	return code ? `${code} · ${name}` : name;
}
